export default [
  '/act-api/api/fallcoupon/couponlist',
  '/act-api/Api/Activitypage/getContent', // 落地页
  '/act-api/api/Recactivity/getRecommendPage', // xgc推荐活动
  '/act-api/api/Recactivity/getSharePage' // xgc被推荐人页
]
